import api from "@/lib/axios";

export const assignmentsApi = {
    list: (params) =>
        api.get("/assignments", { params }).then((r) => r.data),
    get: (id) => api.get(`/assignments/${id}`).then((r) => r.data),
    create: (data) => api.post("/assignments", data).then((r) => r.data),
    update: (id, patch) =>
        api.patch(`/assignments/${id}`, patch).then((r) => r.data),
    end: (id, end_date) =>
        api
            .post(
                `/assignments/${id}/end`,
                null,
                end_date ? { params: { end_date } } : undefined,
            )
            .then((r) => r.data),
    pendingBacklogCount: (id) =>
        api
            .get(`/assignments/${id}/pending-backlog-count`)
            .then((r) => r.data),
    remove: (id) => api.delete(`/assignments/${id}`).then((r) => r.data),
    byIndividual: (individualId) =>
        api
            .get(`/assignments/by-individual/${individualId}`)
            .then((r) => r.data),
    byCaregiver: (caregiverId) =>
        api
            .get(`/assignments/by-caregiver/${caregiverId}`)
            .then((r) => r.data),
};
